import { Button, Icons } from '@cast/design-system';

type Props = {
  onClick: () => void;
};

export const BackButton = ({ onClick }: Props) => (
  <Button
    variant="ghost"
    size="md"
    startIcon={<Icons.ArrowLeft />}
    onClick={onClick}
    testId="back-step-button"
  >
    Back
  </Button>
);
